import React, { useMemo } from 'react';
import TypeButton from '../TypeButton/TypeButton';
import './TypePicker.pcss';

type InputItem = {
  value: string;
  onChange: (buttonType: string) => void;
};

type InnerProps = {
  types: string[];
  input: InputItem;
  className: string;
};

const TypeSelector = (props: InnerProps) => {
  const memoizedTypeSelector = useMemo(() => {
    return props.types.map((buttonType: string) => {
      const selected = buttonType === props.input.value;
      const onClick = () => {
        props.input.onChange(buttonType);
      };
      return (
        <div key={buttonType} className={props.className}>
          <TypeButton
            type={buttonType}
            onClick={onClick}
            isSelected={selected}
          />
        </div>
      );
    });
  }, [props.types]);

  return <div className="type-picker">{memoizedTypeSelector}</div>;
};

export default TypeSelector;
